export default __webpack_public_path__ + "static/media/first-rating-msg.64056649.svg";